import React,{ useState } from 'react';
import home1 from '../../images/home1.png';
import home2 from '../../images/home2.png';
import search1 from '../../images/search1.png';
import search2 from '../../images/search2.png';
import chat1 from '../../images/chat1.png';
import chat2 from '../../images/chat2.png';
import { useNavigate } from 'react-router-dom';
import './navBarScoietyDashBoard.css'


const SocietySideNav = ({ setProgress, Mentor, isFetched}) => {
  const navigate = useNavigate();
  const notifyList = useState([]);

  return (
    <>
      <ul className='side-nav-container-SKILLOP'>
        <li
          onClick={() => {
            navigate('/dashboard');
          }}
        >
          {window.location.pathname === '/Admin_Dashboard' ? (
            <img src={home2} alt='Home' />
          ) : (
            <img src={home1} alt='Home'  />
          )}
          <span
            className={`${
              window.location.pathname === '/Admin_Dashboard' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Dashboard
          </span>
        </li>
        <li
          onClick={() => {
            navigate('/dashboard/members');
          }}
        >
          {window.location.pathname === '/Admin_Users' ? (
            <img src={search2} alt='Home'   />
          ) : (
            <img src={search1} alt='Home'   />
          )}
          <span
            className={`${
              window.location.pathname === '/Admin_Users' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Users
          </span>
        </li>
        <li
          onClick={() => {
            navigate('/Admin_Events');
          }}
        >
          {window.location.pathname === '/Admin_Events' ? (
            <img src={chat2} alt='Home'   />
          ) : (
            <img src={chat1} alt='Home'   />
          )}
          <span
            className={`${
              window.location.pathname === '/Admin_Events' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Add Event
          </span>
        </li>
        <li className='mx-6 text-red-500 rounded-lg hover:bg-red-100 p-8'
          onClick={() => {
            navigate('/homepage');
          }}
        >
          <span
            className={`${
              window.location.pathname === '/homepage' ? 'active2' : ''
            } hover-effect-bottom`}
          >
            Return To Homepage
          </span>
          {notifyList.filter((item) => item.read === false).length > 0 && (
            <div>
              <div className='notify-num-icon'>
                {notifyList.filter((item) => item.read === false).length}
              </div>{' '}
            </div>
          )}
        </li>
      </ul>
    </>
  );
};

export default SocietySideNav;